import React, { useEffect, useRef, useState } from 'react'
import { RouterProps, useNavigate, useParams, Link } from 'react-router-dom'
import logo from '../logo.svg'
import './CategoryList.scss'
import { Helmet } from 'react-helmet-async'
import SideMenu from '../components/SideMenu'
import {
  RootState,
  AppDispatch,
  useAppDispatch,
  notesSlice,
  methods,
  configSlice,
} from '../store'
import { useSelector, useDispatch } from 'react-redux'
import { bindEvent } from '../modules/bindEvent'
import { useTranslation } from 'react-i18next'
import { snackbar, prompt, alert } from '@saki-ui/core'

import { Header } from '../components'
import { api } from '../modules/electron/api'
import { CategoryItem, NoteItem } from '../store/notes/typings'
import { ReaderRouterProps } from '../modules/renderRoutes'
import { protoRoot } from '../protos'
import { SakiContextMenuItem, SakiIcon } from './saki-ui-react/components'

const CategoryListComponent = ({
  onClick,
  list,
  noteId,
}: {
  noteId: string
  list: protoRoot.note.ICategoryItem[]
  onClick: ({ id }: { id: string }) => void
}) => {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  const notes = useSelector((state: RootState) => state.notes)
  const config = useSelector((state: RootState) => state.config)
  const user = useSelector((state: RootState) => state.user)
  const autoCloseWindowAfterCopy = useSelector(
    (state: RootState) => state.config.general.autoCloseWindowAfterCopy
  )
  let history = useNavigate()
  const ref = useRef<any>(null)

  const [showContext, setShowContext] = useState({
    x: 0,
    y: 0,
    label: '',
    visible: false,
  })
  const [contextMenuEl, setContextMenuEl] = useState<any>()

  useEffect(() => {
    if (showContext.visible && contextMenuEl) {
      contextMenuEl?.show({
        x: showContext.x,
        y: showContext.y,
        label: showContext.label,
      })
      return
    }
    setContextMenuEl(undefined)
  }, [showContext.visible, contextMenuEl])

  // console.log('list CategoryListComponent', list)
  return (
    <div className="category-list-component">
      <div className="page-subtitle">
        {t('categories', {
          ns: 'common',
        })}
      </div>
      <saki-menu
        ref={bindEvent({
          selectvalue: async (e) => {
            // console.log(e.detail.value)
            if (e.detail.value === 'addCategory') {
              if (!noteId) {
                snackbar({
                  message: t('noteNotYetAdded', {
                    ns: 'indexPage',
                  }),
                  vertical: 'top',
                  horizontal: 'center',
                  autoHideDuration: 2000,
                  closeIcon: true,
                }).open()
                return
              }
              await dispatch(
                methods.notes.AddCategory({
                  noteId: notes.noteId,
                })
              ).unwrap()
              return
            }
            dispatch(
              notesSlice.actions.selectCategory({
                id: e.detail.value,
              })
            )

            onClick({
              id: e.detail.value,
            })
            // setOpenDropDownMenu(false)
          },
        })}
        padding="0px"
      >
        <saki-drag-sort
          ref={bindEvent({
            dragdone: (e) => {
              // console.log(e.detail)
              dispatch(
                notesSlice.actions.sortCategory({
                  noteId: notes.noteId,
                  sort: {
                    originalIndex: e.detail.oldIndex,
                    targetIndex: e.detail.newIndex,
                  },
                })
              )
            },
          })}
          sort={
            config.deviceType !== 'Mobile' || config.platform === 'Electron'
          }
          key={noteId}
          padding="0px"
        >
          {list
            .filter((v) => (v.status || 0) >= 0)
            .map((v, i) => {
              return (
                <div key={i}>
                  <saki-menu-item
                    ref={bindEvent({
                      opencontextmenu: (e) => {
                        console.log(e)
                        setShowContext({
                          x: e.detail.pageX,
                          y: e.detail.pageY,
                          label: v.id || '',
                          visible: true,
                        })
                      },
                    })}
                    key={i}
                    active={
                      v.id === notes.categoryId ||
                      v.id === list[Number(showContext.label) || -1]?.id
                    }
                    padding="4px 18px"
                    value={v.id}
                  >
                    <div className="cl-item">
                      <span className="text-elipsis">{v.name}</span>
                    </div>
                  </saki-menu-item>
                </div>
              )
            })}
        </saki-drag-sort>
        <saki-menu-item padding="4px 18px" value={'addCategory'}>
          <div className={'cl-item text-elipsis add-category'}>
            <span className="text-elipsis">
              {t('addCategory', {
                ns: 'indexPage',
              })}
            </span>
          </div>
        </saki-menu-item>
      </saki-menu>

      <saki-context-menu
        ref={bindEvent(
          {
            close: () => {
              setShowContext({
                x: 0,
                y: 0,
                label: '',
                visible: false,
              })
            },
            selectvalue: async (e) => {
              if (e.detail.label === 'SortTo') {
                const category = list.filter(
                  (v) => v.id === e.detail.values[1].label
                )?.[0]
                switch (e.detail.value) {
                  case 'MoveToTop':
                    list.some((v, i) => {
                      if (v.id === category.id) {
                        dispatch(
                          notesSlice.actions.sortCategory({
                            noteId: noteId,
                            sort: {
                              originalIndex: i,
                              targetIndex: 0,
                            },
                          })
                        )
                        return true
                      }
                    })
                    break
                  case 'MoveToBottom':
                    list.some((v, i) => {
                      if (v.id === category.id) {
                        dispatch(
                          notesSlice.actions.sortCategory({
                            noteId: noteId,
                            sort: {
                              originalIndex: i,
                              targetIndex: list.length - 1,
                            },
                          })
                        )
                        return true
                      }
                    })
                    break
                }

                return
              }
              const category = list.filter((v) => v.id === e.detail.label)?.[0]
              switch (e.detail.value) {
                case 'HistoricalVersion':
                  console.log('HistoricalVersion')

                  dispatch(
                    configSlice.actions.setShowAsideContentModal({
                      visible: true,
                      data: {
                        noteId: noteId,
                        categoryId: category.id || '',
                        pageId: '',
                        todoId: '',
                        type: 'HistoricalVersion',
                      },
                    })
                  )
                  break
                case 'rename':
                  let name = ''
                  prompt({
                    title: t('rename', {
                      ns: 'common',
                    }),
                    value: category.name || '',
                    placeholder: t('categoryName', {
                      ns: 'indexPage',
                    }),
                    cancelText: t('cancel', {
                      ns: 'common',
                    }),
                    confirmText: t('rename', {
                      ns: 'common',
                    }),
                    onChange(e) {
                      name = e
                      return ''
                    },
                    onCancel() {},
                    onConfirm() {
                      if (!name) {
                        snackbar({
                          message: t('categoryNameNil', {
                            ns: 'indexPage',
                          }),
                          vertical: 'top',
                          horizontal: 'center',
                          autoHideDuration: 2000,
                          closeIcon: true,
                        }).open()
                        return
                      }
                      dispatch(
                        notesSlice.actions.updateCategory({
                          noteId: noteId,
                          categoryId: category.id || '',
                          category: {
                            name,
                          },
                        })
                      )
                    },
                  }).open()
                  break
                case 'delete':
                  alert({
                    title: t('delete', {
                      ns: 'common',
                    }),
                    content: t('deleteThisCategory', {
                      ns: 'common',
                    }),
                    cancelText: t('cancel', {
                      ns: 'common',
                    }),
                    confirmText: t('delete', {
                      ns: 'common',
                    }),
                    onCancel() {},
                    async onConfirm() {
                      dispatch(
                        notesSlice.actions.deleteCategory({
                          noteId: noteId,
                          categoryId: category.id || '',
                        })
                      )
                    },
                  }).open()
                  break

                default:
                  break
              }
            },
          },
          (e) => {
            setContextMenuEl(e)
          }
        )}
      >
        <saki-context-menu-item
          width="140px"
          font-size="13px"
          padding="12px 10px"
          value="rename"
        >
          <div className="context-menu-item">
            <svg
              className="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3909"
            >
              <path
                d="M832 928H192c-52.8 0-96-43.2-96-96V192c0-52.8 43.2-96 96-96h320c17.6 0 32 14.4 32 32s-14.4 32-32 32H192c-17.6 0-32 14.4-32 32v640c0 17.6 14.4 32 32 32h640c17.6 0 32-14.4 32-32V512c0-17.6 14.4-32 32-32s32 14.4 32 32v320c0 52.8-43.2 96-96 96z"
                p-id="3910"
              ></path>
              <path
                d="M404.8 603.2c-12.8-12.8-12.8-33.6 0-44.8L844.8 118.4c12.8-12.8 33.6-12.8 44.8 0 12.8 12.8 12.8 33.6 0 44.8L451.2 603.2c-12.8 12.8-33.6 12.8-46.4 0z"
                p-id="3911"
              ></path>
            </svg>
            <span>
              {t('rename', {
                ns: 'common',
              })}
            </span>
          </div>
        </saki-context-menu-item>

        <saki-context-menu-item
          font-size="13px"
          padding="12px 10px"
          value="SortTo"
        >
          <div className="context-menu-item">
            <saki-icon
              margin="2px 6px 0 0"
              width="18px"
              height="14px"
              type={'Sort'}
            ></saki-icon>
            <span>
              {t('sortTo', {
                ns: 'sakiuiPrompt',
              })}
            </span>
          </div>
          <div slot="SubMenu">
            <saki-context-menu label="SortTo">
              {[
                {
                  icon: 'MoveTop',
                  value: 'MoveToTop',
                  text: t('moveToTop', {
                    ns: 'sakiuiPrompt',
                  }),
                },
                {
                  icon: 'MoveBottom',
                  value: 'MoveToBottom',
                  text: t('moveToBottom', {
                    ns: 'sakiuiPrompt',
                  }),
                },
              ].map((v, i) => {
                return (
                  <saki-context-menu-item
                    key={i}
                    font-size="13px"
                    padding="12px 10px"
                    value={v.value}
                  >
                    <div className="context-menu-item">
                      <saki-icon margin="0 6px 0 0" type={v.icon}></saki-icon>
                      <span>{v.text}</span>
                    </div>
                  </saki-context-menu-item>
                )
              })}
            </saki-context-menu>
          </div>
        </saki-context-menu-item>

        <SakiContextMenuItem
          font-size="13px"
          padding="12px 10px"
          value="HistoricalVersion"
          hide={
            !(
              user.isLogin &&
              notes.list?.filter((v) => v.id === noteId)?.[0]?.isSync
            )
          }
        >
          <div className="context-menu-item">
            <SakiIcon
              color="#666"
              width="17px"
              height="17px"
              margin="0 6px 0 0"
              type="Time"
            ></SakiIcon>
            <span>
              {t('pageTitle', {
                ns: 'historicalVersionPage',
              })}
            </span>
          </div>
        </SakiContextMenuItem>
        <saki-context-menu-item
          width="140px"
          font-size="13px"
          padding="12px 10px"
          value="delete"
        >
          <div className="context-menu-item">
            <saki-icon margin="0 6px 0 0" type="Trash"></saki-icon>
            <span>
              {t('delete', {
                ns: 'common',
              })}
            </span>
          </div>
        </saki-context-menu-item>
      </saki-context-menu>
    </div>
  )
}

export default CategoryListComponent
